import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const ImprintAudit = () => {
  const title = "Mental Health Innovations Audit"

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>{title}</h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on June, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

              {/* <div className={styles.share}>
                <h4>Share This News</h4>
                <div className={styles.icons}>
                  <FacebookFilled />
                  <TwitterSquareFilled />
                  <LinkedinFilled />
                  <LinkOutlined />
                </div>
              </div> */}
            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                {BRAND.domainLabel} is proud to announce that it has consulted Mental
                Health Innovations (MHI) to conduct a comprehensive audit of the
                new social networking platform.
              </p>

              <p>
                MHI is a charity that uses digital innovation, data-driven
                analysis and the experience of clinical experts to transform the
                mental health of the UK population through the provision of
                digital tools, support and resources.
              </p>

              <p>
                This initiative is designed to ensure that {BRAND.domainLabel} aligns
                fully with its internal policy guidelines and upholds the
                highest standards of safety for its users. As part of the audit,
                Dr Fiona Pienaar, Senior Clinical Advisor at MHI, carried out an
                in-depth review of {BRAND.domainLabel}&apos;s content and platform
                processes, assessing compliance, effectiveness, and overall user
                protection measures. She also conducted a review with key youth
                in The MIX community on their thoughts and feedback with regards
                to {BRAND.domainLabel} as both a mindful and competitively feasible
                alternative to other social media platforms. The outcomes of
                this study have helped further shape the platform and its
                offering, while also providing encouraging feedback that there
                is a viable space in the social media marketplace for an
                {BRAND.domainLabel} values-based platform.
              </p>

              <p>
                This collaboration represents a significant step in
                {BRAND.domainLabel}&apos;s ongoing commitment to transparency, quality,
                and building user trust. Beyond the initial audit, {BRAND.domainLabel}
                plans to implement regular reviews in partnership with MHI to
                ensure continuous alignment with industry best practices and
                evolving regulatory standards.
              </p>

              <p>
                By proactively engaging with expert partners like MHI,
                {BRAND.domainLabel} aims to foster a safer and more accountable
                environment, reinforcing its dedication to creating a
                responsible platform for its community.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default ImprintAudit;
